import { Injectable } from '@angular/core';
import { FinancialStatementPart } from '../../models/common/FinancialStatementPart';
import { FsPeriodsFormatterService } from '../common/fs-periods-formatter/fs-periods-formatter.service';
import { ShownPeriodsData } from '../../utils/common/utilityClasses';

@Injectable({
  providedIn: 'root',
})

export class PlService {

  initPlDateColumns(financialStatementPeriod: Date, plParts: FinancialStatementPart[]): ShownPeriodsData {
    const periods = new ShownPeriodsData();
    periods.quarters = FsPeriodsFormatterService.getShownQuarters(plParts, DEFAULT_NUMBER_OF_PERIODS);
    periods.years = FsPeriodsFormatterService.getShownYears(plParts, DEFAULT_NUMBER_OF_PERIODS);
    periods.quarterHeaders = FsPeriodsFormatterService.formatQuartersWithStartAndEnd(periods.quarters);
    periods.yearHeaders = FsPeriodsFormatterService.formatYearsWithStartAndEnd(periods.years, String(financialStatementPeriod));
    return periods;
  }
}

const DEFAULT_NUMBER_OF_PERIODS = 6;
